import React from 'react';
import PageHeader from '../Header/PageHeader';
import Profile from './Profile';

const ProfilePage = () => {
    return (
        <div>
            <PageHeader title="حساب کاربری" />
            <Profile />
        </div>
    );
};

export default ProfilePage;
